module.exports = __webpack_public_path__ + "img/11.54722823.svg";